export default "__VITE_ASSET__Brih2iZV__"